import {
  LocalizeController
} from "./chunk.YKM42GKF.js";
import {
  SolidElement,
  customElement
} from "./chunk.YTLWADMX.js";
import {
  __decorateClass
} from "./chunk.S3NI7NKU.js";

// src/components/loader/loader.ts
import { css, html } from "lit";
import { property } from "lit/decorators.js";
import cx from "classix";
var SdLoader = class extends SolidElement {
  constructor() {
    super(...arguments);
    this.color = "currentColor";
    this.localize = new LocalizeController(this);
  }
  render() {
    return html`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" role="progressbar" aria-label="${this.localize.term("loading")}"><circle class="${cx(
      "dot",
      {
        primary: "text-primary animate-loader-primary",
        white: "text-white animate-loader-white",
        currentColor: "animate-loader-current"
      }[this.color]
    )}" cx="20" cy="12" r="2" fill="currentColor"/><circle class="${cx(
      "dot",
      {
        primary: "text-primary animate-loader-primary",
        white: "text-white animate-loader-white",
        currentColor: "animate-loader-current"
      }[this.color]
    )}" cx="12" cy="12" r="2" fill="currentColor"/><circle class="${cx(
      "dot",
      {
        primary: "text-primary animate-loader-primary",
        white: "text-white animate-loader-white",
        currentColor: "animate-loader-current"
      }[this.color]
    )}" cx="4" cy="12" r="2" fill="currentColor"/></svg>`;
  }
};
/**
 * Inherits global stylesheet including TailwindCSS
 */
SdLoader.styles = [
  ...SolidElement.styles,
  css`:host{display:inline-block;height:1em;width:1em}.dot:nth-child(2){animation-delay:.1s}.dot:first-child{animation-delay:.2s}`
];
__decorateClass([
  property({ type: String, reflect: true })
], SdLoader.prototype, "color", 2);
SdLoader = __decorateClass([
  customElement("sd-5-13-4-loader")
], SdLoader);

export {
  SdLoader
};
